export function createTooltipController() {
  const state = {
    visible: false,
    style: {},
    content: null,
  };

  let hideTimeout = null;

  let isHoveringTooltip = false;
  let isHoveringTarget = false;

  const show = ({ target, component, componentProps }) => {
    clearTimeout(hideTimeout);

    isHoveringTarget = true;

    state.content = { component, props: componentProps };
    state.visible = true;

    requestAnimationFrame(() => {
      const tooltipEl = document.querySelector(".custom-tooltip");
      if (!tooltipEl) return;

      const rect = target.getBoundingClientRect();
      const tooltipRect = tooltipEl.getBoundingClientRect();

      const padding = 8;

      let left = rect.left - tooltipRect.width;
      let top = rect.top + rect.height / 2 - tooltipRect.height / 2;

      if (left < padding) {
        left = rect.right;
      }

      if (left + tooltipRect.width > window.innerWidth - padding) {
        left = window.innerWidth - tooltipRect.width - padding;
      }

      if (top < padding) {
        top = padding;
      }

      if (top + tooltipRect.height > window.innerHeight - padding) {
        top = window.innerHeight - tooltipRect.height - padding;
      }

      state.style = {
        position: "fixed",
        top: top + "px",
        left: left + "px",
        pointerEvents: "auto",
      };
    });
  };

  const enterTarget = () => {
    isHoveringTarget = true;
    cancelHide();
  };

  const leaveTarget = () => {
    isHoveringTarget = false;
    scheduleHide();
  };

  const enterTooltip = () => {
    isHoveringTooltip = true;
    cancelHide();
  };

  const leaveTooltip = () => {
    isHoveringTooltip = false;
    scheduleHide();
  };

  const scheduleHide = (delay = 150) => {
    clearTimeout(hideTimeout);

    hideTimeout = setTimeout(() => {
      if (!isHoveringTooltip && !isHoveringTarget) {
        state.visible = false;
      }
    }, delay);
  };

  const cancelHide = () => {
    clearTimeout(hideTimeout);
  };

  return {
    state,
    show,
    enterTarget,
    leaveTarget,
    enterTooltip,
    leaveTooltip,
    scheduleHide,
    cancelHide,
  };
}
